import React, { useState } from "react";

import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";
import times from "lodash/times";
import Carousel from "nuka-carousel";
import { TouchableOpacity, TouchableHighlight } from "react-native";

import { IMAGES_API_URL } from "../../../api/config";

type Props = {
  images: string[];
  imageSize: number;
};

export default function ImagesCarousel({ images, imageSize }: Props) {
  const [index, setIndex] = useState(0);
  const total = images.length;

  return (
    <div className="flex flex-col justify-center bg-gray-900 relative">
      {total > 1 && (
        <>
          <Arrow
            direction="left"
            hidden={index === 0}
            onPress={() => setIndex(index - 1)}
          />

          <Arrow
            direction="right"
            hidden={index + 1 === total}
            onPress={() => setIndex(index + 1)}
          />
        </>
      )}
      <div className="w-full">
        <Carousel
          slideIndex={index}
          afterSlide={setIndex}
          withoutControls
          disableEdgeSwiping
        >
          {images.map((item, index) => {
            return (
              <img
                className="object-cover w-full h-full"
                key={index}
                src={`${IMAGES_API_URL}/?url=${item}&w=${imageSize}&h=${imageSize}`}
              />
            );
          })}
        </Carousel>
      </div>
      {total > 1 && (
        <div className="flex w-full h-7 justify-center items-center absolute bottom-0">
          {times(total, (curr) => {
            const opacity = curr === index ? "opacity-100" : "opacity-50";
            const style = `w-1.5 h-1.5 m-1 rounded-full bg-gray-300 ${opacity}`;

            return (
              <TouchableHighlight key={curr} onPress={() => setIndex(curr)}>
                <div className={style} />
              </TouchableHighlight>
            );
          })}
        </div>
      )}
    </div>
  );
}

type ArrowProps = {
  direction: "left" | "right";
  onPress: () => void;
  hidden?: boolean;
};

function Arrow({ direction, onPress, hidden }: ArrowProps) {
  if (hidden) return null;

  const Icon = direction === "left" ? ChevronLeftIcon : ChevronRightIcon;
  const x = direction === "left" ? "left-1.5" : "right-1.5";

  return (
    <div className={`absolute px-1.5 z-10 ${x}`}>
      <TouchableOpacity onPress={onPress}>
        <Icon className="h-6 w-6 text-white-100 bg-gray-300 rounded-full bg-opacity-50 shadow" />
      </TouchableOpacity>
    </div>
  );
}
